import { createMixin } from '.';

const useResizeObserver = (controller) => {
  const observers = [];

  controller.createResizeObserver = (callback) => {
    const observer = new ResizeObserver(callback);
    observers.push(observer);
    return observer;
  };

  const disconnect = () => {
    for (const observer of observers) {
      observer.disconnect();
    }
    observers.length = 0;
  };

  return disconnect;
};

/**
 * Allows to create ResizeObservers with automatic cleanup.
 * Meaning that you don't need to manually disconnect observers in disconnect() method.
 * @example Usage
 *   class MyController extends Controller {
 *     connect() {
 *       useResizeObserver(this);
 *       const observer = this.createResizeObserver(
 *         (entries) => entries.forEach((entry) => console.log(entry))
 *       );
 *       observer.observe(this.element);
 *     }
 *   }
 *
 * @param {Object} controller
 * @return {void}
 */
export default createMixin(useResizeObserver);
